// FE4 Duplicate Projects (decision 8 of 14/10: duplicates are projects, managers merge). Contract: BE4-contract-duplicate-
// projects.md on be2's branch. Who may open, dismiss and merge is the new MergeProjects permission (Mohammed's choice B);
// keep every check behind canMergeProjects so a change of rule is one edit.
import { formatCurrency } from '../../utils/money'

export const MERGE_PERMISSION = 'MergeProjects'

/** MergeProjects held above level 0, or an Admin role (role.showAdmin), as the backend checks. Anyone else gets a 403. */
export function canMergeProjects(permissions, profile) {
  const held = (permissions || []).find(a => a && a.permission && a.permission.permissionCode === MERGE_PERMISSION)
  return !!(held && held.permissionLevel > 0) || !!(profile && profile.role && profile.role.showAdmin)
}

export const CONFIDENCES = [
  { value: '', label: 'High and medium' },
  { value: 'HIGH', label: 'High' },
  { value: 'MEDIUM', label: 'Medium' }
]

export const REASONS = {
  SAME_POSTCODE: 'Same full postcode',
  SIMILAR_NAME: 'Similar name',
  SAME_ADDRESS: 'Same address and town'
}

export function reasonLabel(code) {
  return REASONS[code] || code || ''
}

export const PAGE_SIZE = 25

export function emptyFilters() {
  return { confidence: '', search: '', postcodeArea: '', includeDismissed: false }
}

/** The list's query: empty filters left out, the postcode area in capitals, pages counted from 1. */
export function pairParams(filters, pageNo, pageSize) {
  const f = filters || {}
  const params = { includeDismissed: f.includeDismissed === true, pageNo: pageNo || 1, pageSize: pageSize || PAGE_SIZE }
  if (f.confidence) params.confidence = f.confidence
  const search = (f.search || '').trim()
  if (search) params.search = search
  const area = (f.postcodeArea || '').trim().toUpperCase()
  if (area) params.postcodeArea = area
  return params
}

function blank(v) {
  return v === null || v === undefined || v === ''
}

function text(v) {
  return blank(v) ? '' : String(v)
}

// The rows of the side-by-side view, in order: [label, value of one project].
export const SIDE_ROWS = [
  ['Project', p => text(p.name)],
  ['Postcode area', p => text(p.postcodeArea)],
  ['Postcode', p => text(p.postCode)],
  ['Address', p => text(p.address1)],
  ['Town', p => text(p.town)],
  ['Phases', p => text(p.phases)],
  ['Enquiries', p => text(p.jobs)],
  ['Quotations', p => text(p.bids)],
  ['Live quotations', p => text(p.liveBids)],
  ['Value', p => blank(p.value) ? '' : formatCurrency(p.value)],
  ['Created', p => text(p.dateCreated)]
]

/** One pair as table rows: label, project a's value, project b's value, and whether they differ. */
export function sideBySide(pair) {
  const a = (pair && pair.a) || {}
  const b = (pair && pair.b) || {}
  return SIDE_ROWS.map(([label, value]) => {
    const va = value(a)
    const vb = value(b)
    return { label, a: va, b: vb, same: va !== '' && va.toUpperCase() === vb.toUpperCase() }
  })
}

/** The project the user did not pick to keep. */
export function otherOf(pair, keepId) {
  if (!pair || !pair.a || !pair.b) return null
  return pair.a.projectId === keepId ? pair.b : pair.a
}

export function phaseMoveText(m) {
  const name = m.phaseNo === null || m.phaseNo === undefined ? 'Main project' : 'Phase ' + m.phaseNo
  const desc = m.description ? ' (' + m.description + ')' : ''
  return name + desc + (m.into === 'EXISTING' ? ': joins the kept project\'s phase of the same number' : ': moves as a new phase')
}

// sharedEnqId is the job that moves; a JOINS lands on the kept project's targetSharedEnqId.
export function jobMoveText(m) {
  const phase = m.phase ? ' (' + m.phase + ')' : ''
  if (m.into !== 'JOINS') return 'Enquiry ' + m.sharedEnqId + phase + ': moves with its phase'
  const target = blank(m.targetSharedEnqId) ? 'the kept project\'s enquiry for the same phase' : 'enquiry ' + m.targetSharedEnqId
  return 'Enquiry ' + m.sharedEnqId + phase + ': becomes one enquiry with ' + target + '; its customers and attachments move onto it'
}

export function clashText(c) {
  const through = c.branch ? ' through ' + c.branch : ''
  return c.custName + ', ' + c.productType + through + ': quotations ' + c.keepSQuoteNo + ' and ' + c.otherSQuoteNo +
    ' would be on one enquiry. Close or move one of them first.'
}

/** Merge is allowed only when the server says so and nothing clashes. */
export function canConfirmMerge(preview) {
  return !!(preview && preview.canMerge === true && !(preview.clashes || []).length)
}

/** What a refused merge or dismiss says: the server's text, and a 409's clash list (empty otherwise). */
export function refusalOf(e, fallback) {
  const r = e && e.response
  const d = r && r.data
  const message = (d && typeof d === 'object' && d.error) || (typeof d === 'string' && d) || fallback
  return { message, clashes: (r && r.status === 409 && d && Array.isArray(d.clashes)) ? d.clashes : [] }
}
